module.exports = __webpack_public_path__ + "static/media/arrow-up.c415be31.svg";